import React, { useCallback, useState } from 'react';
import styles from './index.module.scss';
import { CnMessage } from '@sto/cn-ui';
import { request } from '@/api/request';
// import { getUpdateUsefulType } from '$src/services/fetchs';

// const img_giveLick_off = "https://imgcdn.sto.cn/38C437E8-361C-40-44x44-Button-Icon%402x.png";
const img_giveLick_off = "https://imgcdn.sto.cn/A5180403-176E-42-16x16-%E7%82%B9%E8%B5%9E%E7%A9%BA%E5%BF%83.svg"; // 点赞空心：移动端的图标
// const img_giveLick_on = "https://imgcdn.sto.cn/B9790E31-BFE0-41-44x44-Button-Icon%402x%20(1).png";
const img_giveLick_on = "https://imgcdn.sto.cn/811C45E8-FC6B-45-16x16-%E7%82%B9%E8%B5%9E%E9%80%89%E4%B8%AD.svg"; // 点赞选中
// const img_tread_on = "https://imgcdn.sto.cn/CB37D5D1-7DF3-49-44x44-Button-Icon%402x%20(3).png";
const img_tread_on = "https://imgcdn.sto.cn/EDB143D3-6E0D-48-16x16-%E7%82%B9%E8%B8%A9%E9%80%89%E4%B8%AD.svg"; // 点踩选中
// const img_tread_off = "https://imgcdn.sto.cn/70962454-96AF-46-44x44-Button-Icon%402x%20(2).png"
const img_tread_off = "https://imgcdn.sto.cn/BFB3196A-5D41-46-16x16-%E7%82%B9%E8%B8%A9%E7%A9%BA%E5%BF%83.svg"; // 点踩空心

const Appraise = (props) => {
  const { usefulType, requestId } = props;
  const [status, setStatus] = useState(usefulType);

  /**
  *
  * @param {*} usefulType 1点赞 2点踩
  * @param {*} id 消息id
  */
  const updateUsefulTypeDt = useCallback((usefulType) => {
    CnMessage.success(usefulType === '2' ? '已收到您的反馈，我们会继续改进' : '谢谢您的反馈。')
    setStatus(usefulType)
    request({
      name: 'robotChat.updateUsefulType',
      params: {
        usefulType,
        requestId,
        platform: 'WEB',
        userClient: 'WEB',
      }
    })
  }, [requestId]);

  return (
    <div className={`${styles.chatWarpLeft} ${styles.appraise}`}>
      <div className={styles.appraiseBox}>
        <div
          className={styles.rightBox}
          onClick={() => {
            updateUsefulTypeDt('1')
          }}
        >
          <img src={status === '1' ? img_giveLick_on : img_giveLick_off} alt="" />
        </div>
        <div
          className={styles.leftBox}
          onClick={() => {
            updateUsefulTypeDt('2')
          }}
        >
          <img src={status === '2' ? img_tread_on : img_tread_off} alt="" />
        </div>
      </div>
    </div>
  )
};

export default Appraise;
